import Diamond from '../../src/legacy/Diamond';
export default Diamond;
